import { render, staticRenderFns } from "./CompanyModulesSetting.vue?vue&type=template&id=a192aa78"
import script from "./CompanyModulesSetting.vue?vue&type=script&lang=js"
export * from "./CompanyModulesSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a192aa78')) {
      api.createRecord('a192aa78', component.options)
    } else {
      api.reload('a192aa78', component.options)
    }
    module.hot.accept("./CompanyModulesSetting.vue?vue&type=template&id=a192aa78", function () {
      api.rerender('a192aa78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyModulesSetting.vue"
export default component.exports